/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_TechnicolorInputs */

const en_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technicolor Format`)
};

const fr_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format Technicolor`)
};

const de_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technicolor-Format`)
};

const it_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Technicolor`)
};

const ru_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат Техниколор`)
};

const es_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Technicolor`)
};

const zh_cn2_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`彩色格式`)
};

const ja_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テクニカラーフォーマット`)
};

const hi_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्नीकलर प्रारूप`)
};

const pt_pt2_ccsl_export_template_technicolor = /** @type {(inputs: Ccsl_Export_Template_TechnicolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Technicolor`)
};

/**
* | output |
* | --- |
* | "Technicolor Format" |
*
* @param {Ccsl_Export_Template_TechnicolorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_technicolor = /** @type {((inputs?: Ccsl_Export_Template_TechnicolorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_TechnicolorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_technicolor(inputs)
	if (locale === "de") return de_ccsl_export_template_technicolor(inputs)
	if (locale === "it") return it_ccsl_export_template_technicolor(inputs)
	if (locale === "ru") return ru_ccsl_export_template_technicolor(inputs)
	if (locale === "es") return es_ccsl_export_template_technicolor(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_technicolor(inputs)
	if (locale === "ja") return ja_ccsl_export_template_technicolor(inputs)
	if (locale === "hi") return hi_ccsl_export_template_technicolor(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_technicolor(inputs)
	return en_ccsl_export_template_technicolor(inputs)
});